import React from 'react';
import { Container, Card, CardHeader, CardBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import '../App.css';

const imageSize = {
    width: '100%',
    maxWidth: '25rem',
    height: 'auto',
    display: 'block',
};

export default function GuidesMainPage () {
    //TODO: Replace the Title with an image banner of the article
    //TODO: Route Guides
    return (
        <Container className="gs-page">
            <div className="gs-page-gutter">
                <header className="gs-page-intro">
                    <h1>Game Guides</h1>
                    <p>FAQ and other helpful guides for Grand Summoners.</p>
                </header>

                <Card className="gs-card">
                    <CardHeader className="gs-card-header">
                        <h2><center>FAQ</center></h2>
                    </CardHeader>
                    <CardBody className="gs-card-body">
                        <div className="gs-guides-grid">
                            <Link to="FAQ" className="gs-banner-link">
                                <img loading="lazy" src="/db/guides/FAQBanner.webp" style={imageSize} alt="FAQ" />
                            </Link>
                        </div>
                    </CardBody>
                </Card>

                <Card className="gs-card" style={{ marginTop: 'var(--gs-space-5)' }}>
                    <CardHeader className="gs-card-header">
                        <h2><center>External Guides</center></h2>
                    </CardHeader>
                    <CardBody className="gs-card-body">
                        <div className="gs-guides-grid">
                            <a className="gs-banner-link" href="https://docs.google.com/document/d/13507_Wa1f7kwP1yoh0L6Js8becdDReofJEwN47v0U3M/" target="_blank" rel="noopener noreferrer">
                                <img loading="lazy" src="/db/guides/DOTBanner.webp" style={imageSize} alt="Dungeon of Trials" />
                            </a>
                            <a className="gs-banner-link" href="https://docs.google.com/document/d/1sTdmOg1K857H7MAuzZWUV4Kk-zwABDG3hl4anyPeAQA/" target="_blank" rel="noopener noreferrer">
                                <img loading="lazy" src="/db/guides/SRBanner.webp" style={imageSize} alt="Summoners' Road" />
                            </a>
                            <a className="gs-banner-link" href="https://docs.google.com/document/d/16IorJQQXMksXIYcNlu3i8iwWTEKeooEpgZG7l-rt4nY/" target="_blank" rel="noopener noreferrer">
                                <img loading="lazy" src="/db/guides/TribalRuinsBanner.webp" style={imageSize} alt="Tribal Ruins" />
                            </a>
                            <a className="gs-banner-link" href="https://docs.google.com/document/d/1OaGohMM8zZsCJ63MEosjiTP2aFStrMRZby7qKGEh6vw/" target="_blank" rel="noopener noreferrer">
                                <img loading="lazy" src="/db/guides/EleRuinsBanner.webp" style={imageSize} alt="Elemental Ruins" />
                            </a>
                            <a className="gs-banner-link" href="https://docs.google.com/document/d/14ztpoBP4MUjuFB1guR0shvLpERMz1r2H4DpfUdcnBMI/" target="_blank" rel="noopener noreferrer">
                                <img loading="lazy" src="/db/guides/GCBanner.webp" style={imageSize} alt="Grand Crusade" />
                            </a>
                            <a className="gs-banner-link" href="https://docs.google.com/document/d/1eERn4m-4WyBbaZIoCkgshY-BqZNpB5ey84uOQsnwv7I/" target="_blank" rel="noopener noreferrer">
                                <img loading="lazy" src="/db/guides/MinesBanner.webp" style={imageSize} alt="Magical Mines" />
                            </a>
                        </div>
                    </CardBody>
                </Card>
            </div>
        </Container>
    )
}
